import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'app-form-selector',
  templateUrl: './form-selector.component.html',
  styleUrls: ['./form-selector.component.less']
})
export class FormSelectorComponent implements OnInit {

  forms:any;
  _formId:number;

  @Input() public formModel:string;
  public _pathInModel:string;
  
  @Input() formid:number;
  @Output() formidChange:EventEmitter<number> = new EventEmitter<number>();
  
  constructor(private ds:DataService) { }

  @Input() set pathInModel(value:string){
    this._pathInModel = value;
    this.refresh();
  }

  get pathInModel():string{
    return this._pathInModel;
  }
  

  ngOnInit() {
   this.loadItems();
  }

  loadItems(){
    this.ds.getModelForms(btoa(this.formModel), btoa(this.pathInModel)).subscribe(
      data => this.mapData(data)
    );
  }

  mapData(data){
    this.forms = data;
  }

  refresh(){
    //alert(this.pathInModel);
    this.loadItems();
  }

  selecteValueChange(event){
    this.formidChange.emit(event.target.value);
  }
}
